import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SalonService } from '../service/salon.service';

export const salonResolver: ResolveFn<void> = async (route) => {
  const salonId = route.paramMap.get('salonId');
  // console.log(`salon with id ${salonId} is being loaded`);

  if (salonId) {
    void inject(SalonService).init(salonId);
  }
};
